export enum DatePickerType {
	DATE_AND_TIME = 'both',
	DATE_ONLY = 'calendar',
	TIME_ONLY = 'timer',
}
